"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styled = require("./styled");

var _Options = _interopRequireDefault(require("./Options"));

var _hooks = require("../../hooks");

var _StyledTippy = _interopRequireDefault(require("../StyledTippy"));

var OptionsIcon = function OptionsIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "2.5",
    cy: "18.5",
    r: "2.5",
    fill: "#73819B"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "2.5",
    cy: "10.5",
    r: "2.5",
    fill: "#73819B"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "2.5",
    cy: "2.5",
    r: "2.5",
    fill: "#73819B"
  }));
};

OptionsIcon.defaultProps = {
  width: "5",
  height: "21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var tippyProps = {
  placement: "bottom",
  interactive: true,
  interactiveDebounce: 75,
  offset: [0, -8]
};

var OptionsDropdown = function OptionsDropdown(_ref) {
  var options = _ref.options;
  var ref = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      showOptions = _useState2[0],
      setShowOptions = _useState2[1];

  var handleShowOptions = function handleShowOptions(event) {
    event === null || event === void 0 ? void 0 : event.preventDefault();
    setShowOptions(!showOptions);
  };

  var handleClickOutside = function handleClickOutside(event) {
    event === null || event === void 0 ? void 0 : event.preventDefault();

    if (!showOptions) {
      return;
    }

    setShowOptions(false);
  };

  (0, _hooks.useClickOutside)(ref, handleClickOutside);
  return /*#__PURE__*/_react["default"].createElement("span", {
    ref: ref
  }, /*#__PURE__*/_react["default"].createElement(_StyledTippy["default"], (0, _extends2["default"])({}, tippyProps, {
    visible: showOptions,
    content: /*#__PURE__*/_react["default"].createElement(_Options["default"], {
      options: options,
      onClose: handleShowOptions
    })
  }), /*#__PURE__*/_react["default"].createElement(_styled.OptionsIconButton, {
    onClick: handleShowOptions
  }, /*#__PURE__*/_react["default"].createElement(OptionsIcon, null))));
};

var _default = OptionsDropdown;
exports["default"] = _default;